import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectPersonRelationApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'projectPersonRelation'
  }

}